import React, { useState, useEffect, Fragment } from "react";
import { ThemeProvider } from "styled-components";
import Sticky from "react-stickynode";
import { Modal } from "@redq/reuse-modal";
import { appTheme } from "common/src/theme/app";
import {
  GlobalStyle,
  AppWrapper,
  ConditionWrapper
} from "../../containers/App/app.style";
import { ResetCSS } from "common/src/assets/css/style";
import Navbar from "../../containers/App/Navbar";
import Blogroll from "../../containers/App/Blogroll";
import Footer from "../../containers/App/Footer";
import { DrawerProvider } from "common/src/contexts/DrawerContext";
import "@redq/reuse-modal/es/index.css";
import SEO from "../../components/seo";
import Container from "common/src/components/UI/Container";

function getSize() {
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth
  };
}

function useWindowSize() {
  let [windowSize, setWindowSize] = useState(getSize());

  function handleResize() {
    setWindowSize(getSize());
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}

export default () => {
  const size = process.browser && useWindowSize();
  const innerWidth = process.browser && size.innerWidth;

  return (
    <ThemeProvider theme={appTheme}>
      <Fragment>
        <SEO title="Ordoo" />
        <Modal />
        <ResetCSS />
        <GlobalStyle />
        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <Container>
            <div>
              <div class="container">
                <br />
                <br />
                <br />
                <br />
                <br />
                <div class="container">
                  <div>
                    This privacy policy applies between you, the User accessing
                    services through our Website or mobile application and ORDOO
                    LTD., the owner and provider of this Website and mobile
                    application. ORDOO LTD. takes the privacy of your
                    information very seriously. This privacy policy applies to
                    our use of any and all data collected by us or provided by
                    you in relation to your use of the Website and mobile
                    application. Please read this privacy policy carefully.
                  </div>
                  <div>
                    <h2 class="terms-head-text">1. Information about us</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          1.1. In this privacy policy, the following definitions
                          are used:
                        </div>
                      </li>
                      <li>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">Data</div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              Collectively all information that you submit to
                              ORDOO LTD. via the Website or Mobile application.
                              This definition incorporates, where applicable,
                              the definitions provided in the Data Protection
                              Act 1998;
                            </div>
                          </div>
                        </div>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">
                              ORDOO LTD., or us or we
                            </div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              ORDOO LTD., a company incorporated in England and
                              Wales with registered number 09660723 whose
                              registered office is at University of Bath
                              Innovation Centre, Carpenter House, Somerset, BA1
                              1UD;
                            </div>
                          </div>
                        </div>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">User or you</div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              Any third party that accesses the Website and is
                              not either (i) employed by ORDOO LTD. and acting
                              in the course of their employment or (ii) engaged
                              as a consultant or otherwise providing services to
                              ORDOO LTD. and accessing the Website in connection
                              with the provision of such services;
                            </div>
                          </div>
                        </div>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">Website</div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              The website that you are currently using,
                              www.ordoo.co.uk, and any sub-domains of this site
                              unless expressly excluded by their own terms and
                              conditions.
                            </div>
                          </div>
                        </div>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">
                              Mobile application
                            </div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              The mobile application developed by and for Ordoo
                              as available on Apple’s App store and Google play
                              store.
                            </div>
                          </div>
                        </div>
                        <div class="terms-row w-row">
                          <div class="w-col w-col-6">
                            <div class="terms-text-2 bold">Partner venue</div>
                          </div>
                          <div class="w-col w-col-6">
                            <div>
                              An store on the mobile application where users can
                              buy items from a menu. The owners have access to a
                              management portal.
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          1.2. For avoidance of doubt, Ordoo’s online services
                          include both a website and mobile application,
                          referred together throughout as “website”. This
                          includes attempts to access Ordoo’s services via other
                          digital channels including, but not limited to, mobile
                          tablets and other devices.
                        </div>
                      </li>
                      <li>
                        <div>
                          1.3. In this privacy policy, unless the context
                          requires a different interpretation:
                        </div>
                      </li>
                      <li>
                        <ul class="terms-list w-list-unstyled">
                          <li>
                            <div>
                              1.3.1. The singular includes the plural and vice
                              versa;
                            </div>
                          </li>
                          <li>
                            <div>
                              1.3.2. References to sub-clauses, clauses,
                              schedules or appendices are to sub-clauses,
                              clauses, schedules or appendices of this privacy
                              policy;
                            </div>
                          </li>
                          <li>
                            <div>
                              1.3.3. A reference to a person includes firms,
                              companies, government entities, trusts and
                              partnerships;
                            </div>
                          </li>
                          <li>
                            <div>
                              1.3.4. "Including" is understood to mean
                              "including without limitation";
                            </div>
                          </li>
                          <li>
                            <div>
                              1.3.5. Reference to any statutory provision
                              includes any modification or amendment of it;
                            </div>
                          </li>
                          <li>
                            <div>
                              1.3.6. The headings and sub-headings do not form
                              part of this privacy policy.
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      2. Scope of this privacy policy
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          2.1. This privacy policy applies only to the actions
                          of ORDOO LTD. and Users with respect to this Website
                          and mobile application. It does not extend to any
                          websites that can be accessed from this Website
                          including, but not limited to, any links we may
                          provide to social media websites.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">3. Data collected</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          3.1. We may collect the following Data, which includes
                          personal Data, from you:
                        </div>
                      </li>
                      <li>
                        <div class="data-collected-table-cont">
                          <div class="data-collected-table w-row">
                            <div class="data-collected-col1 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Type of data</div>
                            </div>
                            <div class="data-collected-col2 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Purpose</div>
                            </div>
                            <div class="data-collected-col3 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Legal Basis</div>
                            </div>
                          </div>
                          <div class="data-collected-table w-row">
                            <div class="data-collected-col1 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>First and Surname</div>
                            </div>
                            <div class="data-collected-col2 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>
                                Used for order redemption and identification
                                between the venue and customer
                              </div>
                            </div>
                            <div class="data-collected-col3 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Consent</div>
                            </div>
                          </div>
                          <div class="data-collected-table w-row">
                            <div class="data-collected-col1 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Email address</div>
                            </div>
                            <div class="data-collected-col2 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>
                                This is used as an unique identifier for orders.
                                It is also required to send an order receipt.
                                Finally, it may be used for marketing purposes
                                if consent given by the customer.
                              </div>
                            </div>
                            <div class="data-collected-col3 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Consent</div>
                            </div>
                          </div>
                          <div class="data-collected-table w-row">
                            <div class="data-collected-col1 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Location Data</div>
                            </div>
                            <div class="data-collected-col2 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>
                                Used to ensure the order is made when the
                                customer is near. It may be used for marketing
                                purposes if consent given by the customer.
                              </div>
                            </div>
                            <div class="data-collected-col3 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Legitimate interest</div>
                            </div>
                          </div>
                          <div class="data-collected-table last w-row">
                            <div class="data-collected-col1 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Activity Data</div>
                            </div>
                            <div class="data-collected-col2 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>
                                Information is collected on total customer
                                spend, average order value, order frequency and
                                number of referrals. This information is shared
                                with any venues where a customer has placed an
                                order.
                              </div>
                            </div>
                            <div class="data-collected-col3 w-col w-col-4 w-col-small-4 w-col-tiny-4">
                              <div>Legitimate interest</div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div>
                          3.2. In each case, in accordance with this privacy
                          policy.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">4. Our use of Data</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          4.1. Ordoo collect data in order to perform the
                          services requested by the user.
                        </div>
                      </li>
                      <li>
                        <div>
                          4.2. For purposes of the Data Protection Act 1998,
                          ORDOO LTD. is the "data controller".
                        </div>
                      </li>
                      <li>
                        <div>
                          4.3. We collect information from you when you register
                          on our mobile application, place an order or enter
                          information on our website.
                        </div>
                      </li>
                      <li>
                        <div>
                          4.4. Unless we are obliged or permitted by law to do
                          so, and subject to any third party disclosures
                          specifically set out in this policy, your Data will
                          not be shared with third parties.
                        </div>
                      </li>
                      <li>
                        <div>
                          4.5. This does not include our partner venues on the
                          Ordoo platform. Data may be disclosed to selected
                          partners when users have placed an order at specific
                          venues. If a user does not place an order then no data
                          will be shared with partner venues.
                        </div>
                      </li>
                      <li>
                        <div>
                          4.6. All personal Data is stored securely in
                          accordance with the principles of the Data Protection
                          Act 1998. For more details on security see the clause
                          11 below (Security).
                        </div>
                      </li>
                      <li>
                        <div>
                          4.7. Any or all of the above Data may be required by
                          us from time to time in order to provide you with the
                          best possible service and experience when using our
                          Website. Specifically, Data may be used by us for the
                          following reasons:
                        </div>
                      </li>
                      <li>
                        <ul class="terms-list w-list-unstyled">
                          <li>
                            <div>4.7.1. Internal record keeping;</div>
                          </li>
                          <li>
                            <div>
                              4.7.2. Improvement of our products / services;
                            </div>
                          </li>
                          <li>
                            <div>
                              4.7.3. To personalize user's experience and to
                              allow us to deliver the type of content and
                              product offerings in which you are most
                              interested;
                            </div>
                          </li>
                          <li>
                            <div>
                              4.7.4. Contact for market research purposes which
                              may be done using email, telephone, or mail. Such
                              information may be used to customise or update the
                              Website;
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div>
                          4.8. in each case, in accordance with this privacy
                          policy.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      5. Third party websites and services
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          5.1. ORDOO LTD. may, from time to time, employ the
                          services of other parties for dealing with certain
                          processes necessary for the operation of the Website
                          and mobile application. The providers of such services
                          do not have access to certain personal Data provided
                          by Users of this Website.
                        </div>
                      </li>
                      <li>
                        <div>
                          We use the following third party(s) to conduct
                          business with legitimate interest:
                        </div>
                      </li>
                      <li>
                        <ul class="terms-list w-list-unstyled">
                          <li>
                            <div>
                              5.2.1. Mixpanel –{" "}
                              <a
                                href="https://mixpanel.com/privacy/"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.2. Stripe –{" "}
                              <a
                                href="https://stripe.com/gb/privacy"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.3. Mailchimp –{" "}
                              <a
                                href="https://mailchimp.com/legal/privacy/"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.4 Close comms –{" "}
                              <a
                                href="https://closecomms.com/wi-fi-app-terms-of-use/"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.5 Facebook –{" "}
                              <a
                                href="https://www.facebook.com/full_data_use_policy"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.6 Google –{" "}
                              <a
                                href="https://policies.google.com/privacy?hl=en-GB&amp;gl=uk"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.7 Lead Forensics –{" "}
                              <a
                                href="https://www.leadforensics.com/privacy-and-cookies/"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.8 Zoho Corporation –{" "}
                              <a
                                href="https://www.zoho.com/privacy.html"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              5.2.9 Intercom –{" "}
                              <a
                                href="https://www.intercom.com/terms-and-policies#terms"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div>
                          5.3. We may also release your information when we
                          believe release is appropriate to comply with the law,
                          enforce our site policies, or protect ours or others'
                          rights, property, or safety.
                        </div>
                      </li>
                      <li>
                        <div>
                          5.4. non-personally identifiable visitor information
                          may be provided to other parties for marketing,
                          advertising, or other uses.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">6. Links to other websites</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          6.1. This Website may, from time to time, provide
                          links to other websites. We have no control over such
                          websites and are not responsible for the content of
                          these websites. This privacy policy does not extend to
                          your use of such websites. You are advised to read the
                          privacy policy or statement of other websites prior to
                          using them.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      7. Changes of business ownership and control
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          7.1. ORDOO LTD. may, from time to time, expand or
                          reduce our business and this may involve the sale
                          and/or the transfer of control of all or part of ORDOO
                          LTD., Data provided by Users will, where it is
                          relevant to any part of our business so transferred,
                          be transferred along with that part and the new owner
                          or newly controlling party will, under the terms of
                          this privacy policy, be permitted to use the Data for
                          the purposes for which it was originally supplied to
                          us.
                        </div>
                      </li>
                      <li>
                        <div>
                          7.2. We may also disclose Data to a prospective
                          purchaser of our business or any part of it.
                        </div>
                      </li>
                      <li>
                        <div>
                          7.3. In the above instances, we will take steps with
                          the aim of ensuring your privacy is protected.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      8. Controlling use of your Data
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          8.1. Wherever you are required to submit Data, you
                          will be given options to restrict our use of that
                          Data. This may include the following:
                        </div>
                      </li>
                      <li>
                        <ul class="terms-list w-list-unstyled">
                          <li>
                            <div>
                              8.1.1. Use of Data for direct marketing purposes;
                              and
                            </div>
                          </li>
                          <li>
                            <div>8.1.2. Sharing Data with third parties.</div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div>
                          8.2. Restrictions to the data can be managed in the
                          settings section of the mobile application and upon
                          request to the support team.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      9. Functionality of the Website and mobile application
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          9.1. To use all features and functions available on
                          the Website, you may be required to submit certain
                          Data.
                        </div>
                      </li>
                      <li>
                        <div>
                          9.2. To make a purchase within the mobile application
                          you will be required to register and submit required
                          information.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">10. Accessing your own Data</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          10.1. You have the right to ask for a copy of any of
                          your personal Data held by ORDOO LTD. (where such Data
                          is held in accordance with this privacy policy).
                        </div>
                      </li>
                      <li>
                        <div>
                          10.1. Where data is inaccurate, the individual
                          concerned has a right to apply to rectify, block,
                          erase or destroy the inaccurate information. Please
                          contact Ordoo support to rectify this issue.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">11. Security</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li id="my-rewards">
                        <div>
                          11.1. Data security is of great importance to ORDOO
                          LTD. and to protect your Data we have put in place
                          suitable physical, electronic and managerial
                          procedures to safeguard and secure Data collected via
                          this Website.
                        </div>
                      </li>
                      <li>
                        <div>
                          11.2. We will never have access to sensitive billing
                          information such as credit card or bank account
                          details, even though you're paying for items via the
                          app. This sensitive data is handled by the following
                          3rd party payment provider:
                        </div>
                      </li>
                      <li>
                        <ul class="terms-list w-list-unstyled">
                          <li>
                            <div>
                              11.2.1. Stripe –{" "}
                              <a
                                href="https://stripe.com/gb/privacy"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                          <li>
                            <div>
                              11.2.2 GoCardless –{" "}
                              <a
                                href="https://gocardless.com/legal/privacy/"
                                target="_blank"
                                class="privacy-span-link"
                              >
                                Privacy policy
                              </a>
                              .
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div>
                          11.3 The mobile application is hosted and stored with
                          Amazon Web Services in accordance with their{" "}
                          <a
                            href="https://stripe.com/gb/privacy"
                            target="_blank"
                            class="privacy-span-link"
                          >
                            privacy policy here.
                          </a>
                        </div>
                      </li>
                      <li>
                        <div>
                          11.4. If password access is required for certain parts
                          of the Website, you are responsible for keeping this
                          password confidential.
                        </div>
                      </li>
                      <li>
                        <div>
                          11.5. We endeavour to do our best to protect your
                          personal Data. However, transmission of information
                          over the internet is not entirely secure and is done
                          at your own risk. We cannot ensure the security of
                          your Data transmitted to the Website.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">12. General</h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          12.1. You may not transfer any of your rights under
                          this privacy policy to any other person. We may
                          transfer our rights under this privacy policy where we
                          reasonably believe your rights will not be affected.
                        </div>
                      </li>
                      <li>
                        <div>
                          12.2. If any court or competent authority finds that
                          any provision of this privacy policy (or part of any
                          provision) is invalid, illegal or unenforceable, that
                          provision or part-provision will, to the extent
                          required, be deemed to be deleted, and the validity
                          and enforceability of the other provisions of this
                          privacy policy will not be affected.
                        </div>
                      </li>
                      <li>
                        <div>
                          12.3. Unless otherwise agreed, no delay, act or
                          omission by a party in exercising any right or remedy
                          will be deemed a waiver of that, or any other, right
                          or remedy.
                        </div>
                      </li>
                      <li>
                        <div>
                          12.4. This privacy policy is governed by and
                          interpreted according to English law. All disputes
                          arising under this privacy policy are subject to the
                          exclusive jurisdiction of the English courts.
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h2 class="terms-head-text">
                      13. Changes to this privacy policy
                    </h2>
                    <ul class="terms-list w-list-unstyled">
                      <li>
                        <div>
                          13.1. ORDOO LTD. reserves the right to change this
                          privacy policy as we may deem necessary from time to
                          time or as may be required by law. Any changes will be
                          immediately posted on the Website and you are deemed
                          to have accepted the terms of the privacy policy on
                          your first use of the Website following the
                          alterations.
                        </div>
                      </li>
                      <li>
                        <div>
                          13.2. You may contact ORDOO LTD. by email at{" "}
                          <a
                            href="mailto:info@ordoo.co.uk?subject=Email%20from%20Ordoo%20Privacy%20Policy"
                            class="privacy-span-link"
                          >
                            info@ordoo.co.uk
                          </a>
                          .
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Container>

          <Footer />
        </AppWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
